import { Typography, useMediaQuery, useTheme } from "@mui/material";
import { motion } from "framer-motion";
import { memo } from "react";
import { IGracePeriodCptDataProps } from "./models";
import { GracePeriodCptTable } from "./GracePeriodCptTable/GracePeriodCptTable";
import NoData from "../../UI/NoData";
import { GracePeriodCptList } from "./GracePeriodCptList/GracePeriodCptList";

export const GracePeriodCptData = memo(
  ({ label, noDataMessage, loading, data }: IGracePeriodCptDataProps) => {
    const theme = useTheme();

    const matches = useMediaQuery(theme.breakpoints.down("md"));

    return (
      <motion.div
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -10 }}
        transition={{ duration: 0.5, ease: [0.6, -0.05, 0.01, 0.99] }}
        style={{
          marginBottom: theme.spacing(2),
          height: "100%",
          width: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography variant="h6">{label}</Typography>
        {!loading && data.length === 0 && <NoData message={noDataMessage} />}
        {(loading || data.length > 0) && matches && (
          <GracePeriodCptList data={data} loading={loading} />
        )}
        {(loading || data.length > 0) && !matches && (
          <GracePeriodCptTable data={data} loading={loading} />
        )}
      </motion.div>
    );
  }
);
